
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { TimelineMax } from 'gsap';
import { TestPlace } from '@/models/test-place.model';

@Component({})
export default class HomeIdeasPlaceInfo extends Vue {
  @Prop({ required: true })
  info!: TestPlace;
  @Ref() placeContainer: any;

  isOpen: boolean = false;
  animation!: TimelineMax;

  mounted() {
    // @ts-ignore
    this.placeContainer.style.backgroundImage = `url(${this.info.backgroundImage})`;

    // Create animation instance.
    this.animation = new TimelineMax();
  }

  toggleExpand() {
    // @ts-ignore
    const { y } = this.placeContainer.getBoundingClientRect();

    if (!this.isOpen) {
      this.animation.to(this.placeContainer, 0.5, {
        y: -y,
        height: '100vh',
        zIndex: 10
      });
    } else {
      this.animation.to(this.placeContainer, 0.25, {
        y: 0,
        height: '33.34vh',
        zIndex: 0
      });
    }
    this.isOpen = !this.isOpen;
  }

  get mobileScrollText() {
    return this.$vuetify.breakpoint.smAndDown
      ? 'allow-scroll allow-normal-scroll'
      : '';
  }

  get mobileTextStyle() {
    return this.$vuetify.breakpoint.smAndDown
      ? 'ml-5 mt-12 mr-5 white--text'
      : 'ml-4 mt-12 mr-12 white--text';
  }

  // openSitePage(url?: string) {
  //   window.open(url, '_blank');
  // }
}
